import React, {FC} from 'react';
import StarIcon from 'components/icons/StarIcon';
import {motion} from 'framer-motion';
import {range} from 'lodash';

import './index.scss';

const Stars: FC<{rating: number}> = ({rating}) => {
	const staggerChildren = 0.13;
	const containerProps = {
		className: 'user-reviews-stars',
		initial: 'hidden',
		whileInView: 'show',
		viewport: {once: true},

		variants: {
			show: {
				transition: {
					staggerChildren,
				},
			},
		}
	};

	const itemProps = {
		variants: {
			hidden: {
				opacity: 0,
			},
			show: {
				opacity: 1,
			},
		},
	};

	return (
		<motion.div {...containerProps}>
			{range(0, rating).map((_, index) => (
				<motion.div {...itemProps} key={index}>
					<StarIcon />
				</motion.div>
			))}
		</motion.div>
	);
};

export default Stars;
